import React from 'react';
import '../styles/About.css';

const About = () => {
  return (
    <div className="about-page">
      <div className="about-container">
        <h1>About OneMart</h1>
        
        <section className="about-section">
          <h2>Company Introduction</h2>
          <p>
            Welcome to OneMart, your premier destination for quality products and exceptional service. 
            Since our founding, we've been committed to bringing you the best shopping experience possible.
          </p>
        </section>

        <section className="about-section">
          <h2>Our Mission</h2>
          <p>
            Our mission is to provide customers with high-quality products at competitive prices while 
            delivering outstanding customer service. We believe in making online shopping easy, secure, 
            and enjoyable for everyone.
          </p>
        </section>

        <section className="about-section">
          <h2>Our Vision</h2>
          <p>
            We envision a world where shopping is seamless, sustainable, and accessible to all. 
            Through innovation and dedication, we strive to be the leading eCommerce platform that 
            customers trust and love.
          </p>
        </section>

        <section className="about-section">
          <h2>Business Background</h2>
          <p>
            Founded in 2020, OneMart has grown from a small startup to a thriving online marketplace. 
            We've served thousands of satisfied customers and continue to expand our product range and 
            services. Our team is passionate about eCommerce and dedicated to your satisfaction.
          </p>
        </section>

        <section className="about-section">
          <h2>Our Services</h2>
          <div className="services-grid">
            <div className="service-card">
              <h3>🚚 Fast Shipping</h3>
              <p>Quick and reliable delivery to your doorstep</p>
            </div>
            <div className="service-card">
              <h3>💳 Secure Payment</h3>
              <p>Safe and encrypted payment processing</p>
            </div>
            <div className="service-card">
              <h3>🔄 Easy Returns</h3>
              <p>Hassle-free return and exchange policy</p>
            </div>
            <div className="service-card">
              <h3>💬 24/7 Support</h3>
              <p>Round-the-clock customer assistance</p>
            </div>
          </div>
        </section>
      </div>
    </div>
  );
};

export default About;
